import { Col, Form, InputNumber, Row } from 'antd';
import React, { useEffect } from 'react';


const MultiDecimalControl = ({
    name,
    defaultValue,
    required,
    errorMessage,
    controlWidth,
    disabled,
    label,
    controlsNo,
    placeholder,
    form,
}) => {

    useEffect(() => {
        form.setFieldValue(name, defaultValue);
    }, []);

    const isRequired = (index) => {
        if (typeof (required) === 'boolean') {
            return required;
        };
        if (typeof (required) === 'object') {
            return required[index]
        }
    }

    return (
        <>
            <Row>
                <Col span={24} className='ant-form-item-label ant-form-item-label-wrap' style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
                    <label className={`${required ? 'ant-form-item-required' : ''} ant-form-item-no-colon`} title={label}>{label}</label>
                </Col>
            </Row>
            <div style={{ display: 'inline-flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                {
                    Array.from({ length: controlsNo }).map((_, idx) => (
                        <Form.Item
                            key={name + "input" + idx}
                            name={[name, idx]}
                            style={{ width: controlWidth[idx] }}
                            rules={[
                                { required: isRequired(idx), message: errorMessage }
                            ]}
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                step={0.1}
                                disabled={disabled}
                                placeholder={placeholder}
                            />
                        </Form.Item>
                    ))
                }
            </div>
        </>
    )
};

export default MultiDecimalControl;